import { Injectable } from '@angular/core';
import { Router } from '@angular/router';
import { HttpClient, HttpHeaders, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { HttpError } from '../models/http-error.model';
import { catchError } from 'rxjs/operators';
import { throwError } from 'rxjs/internal/observable/throwError';
import { environment } from 'src/environments/environment';

@Injectable({
  providedIn: 'root'
})
export class HttpService {
  baseUrl = environment.baseUrl;

  constructor(private http: HttpClient, public router: Router) {}

  public request(
    method: string,
    url: string,
    data: any = null,
    contentType = 'application/json'
  ): any {
    let headers = new HttpHeaders({
      'Content-Type': contentType
    });
    if (contentType === 'multipart/form-data') {
      headers = headers.delete('Content-Type');
    }
    if (data) {
      if (method === 'post') {
        return this.http.post(`${this.baseUrl}${url}`, data, {
          headers
        });
      }
      if (method === 'put') {
        return this.http.put(`${this.baseUrl}${url}`, data, {
          headers
        });
      }
    }
    if (method === 'get') {
      data = data ? '?' + Object.entries(data).map(param => `${param[0]}=${param[1]}`).join('&') : '';
      return this.http.get(`${this.baseUrl}${url}${data}`, {
        headers,
        withCredentials: true
      });
    }
    if (method === 'delete') {
      return this.http.delete(`${this.baseUrl}${url}`, {
        headers,
        withCredentials: true
      });
    }
  }
}
